/* tslint:disable */
/* eslint-disable */
/**
 * Topas Aggregates
 * A cloud microservice designed to send real-time updates to clients for their aggregates, as well as an API, making aggregates readily available to clients, allowing them to access and utilize the necessary data effectively.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-personell-it@vy.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export const DayPlanTrackingStatus = {
  SENT: "SENT",
  RECEIVED: "RECEIVED",
  RECEIVED_BEFORE_START: "RECEIVED_BEFORE_START",
  READ: "READ",
  MANUAL: "MANUAL",
  OUTDATED: "OUTDATED",
} as const;

export type DayPlanTrackingStatus = keyof typeof DayPlanTrackingStatus;


export function instanceOfDayPlanTrackingStatus(value: any): boolean {
    for (const key in DayPlanTrackingStatus) {
        if (Object.prototype.hasOwnProperty.call(DayPlanTrackingStatus, key)) {
            if (DayPlanTrackingStatus[key as keyof typeof DayPlanTrackingStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DayPlanTrackingStatusFromJSON(json: any): DayPlanTrackingStatus {
    return DayPlanTrackingStatusFromJSONTyped(json, false);
}

export function DayPlanTrackingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): DayPlanTrackingStatus {
    return json as DayPlanTrackingStatus;
}

export function DayPlanTrackingStatusToJSON(value?: DayPlanTrackingStatus | null): any {
    return value as any;
}

export function DayPlanTrackingStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): DayPlanTrackingStatus {
    return value as DayPlanTrackingStatus;
}

